import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoGoalsGetRes } from "./abst/DtoGoalsGetRes";

export class DtoGoalsGetResImple extends DtoGoalsGetRes {
  public pager = new DtoApiPager();
}
